export function getRotateAnimation (element, settings) {
    const rotation = {
        //Change de rotation based on the direction
        rotation: `${settings.rotation}deg`
    };
    if (settings.withFade ?? true) {
        rotation.opacity = 0
    }

    if( settings.transformOrigin ){
        //"left top | 50% 50%"
        rotation.transformOrigin = settings.transformOrigin;
    }

    return rotation;
}

